import { NetworkHelper } from '../module/index';
import {
  Hotel,
  Suggest,
  Search,
  HotelSearchCriteria,
  Currency,
  Lang,
  Configurator,
  InitRequest,
  FetchRequest,
  HotelDetailsML,
  HotelOffers,
} from 'types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import store from './../../store';

import { ApiModule } from '../module/networkModule';

const DEFAULT_LANG = Lang.DEFAULT_LANG();
export namespace HotelService {
  export const offersMl = (hotelId: string, json: any, locale: string) => {
    const testTool: Configurator.State = Configurator.builder();

    if (testTool) {
      json['source_settings'] = testTool.eps.toRequestBody(
        testTool.hotelModule.showSupplierMetaData,
      );
    }

    return ApiModule.get()
      .apiML.get<HotelOffers.Response>(`/hotel/${hotelId}/offers`, json)
      .pipe(
        map(it => {
          const tmp = { ...it };
          tmp.data.locale = locale;
          return tmp;
        }),
      );
  };

  export const policyMl = (hotelId: string, offerId: string) => {
    return ApiModule.get()
      .apiML.get<{
        data: HotelOffers.Policy;
      }>(`/hotel/${hotelId}/offers/${offerId}/policy`)
      .pipe(
        map(it => {
          return it.data;
        }),
      );
  };

  export const getHotelv2 = (
    body: HotelSearchCriteria,
    currency: Currency.CURRENCIES,
  ) => {
    const locale = store.state.support.lang.locale || DEFAULT_LANG.locale;
    const json = body.hotelRequestBody();

    return offersMl(body.id, json, locale);
  };

  export const hotelSuggest = (query: string) => {
    const args = {
      query,
      language: store.state.support.lang.locale || DEFAULT_LANG.locale,
      mode: 1,
    };

    return ApiModule.get().apiML.get<Suggest.HotelSuggests>('/suggest', args);
  };

  export const searchV2Init = (
    criteria: InitRequest,
    nights: number,
    dropRoomId?: string,
  ): Observable<Search.SearchResultsV2> => {
    const query = { ...criteria, ...NetworkHelper.getUTMParams() };

    if (dropRoomId) {
      query['drop_room_id'] = dropRoomId;
    }

    return ApiModule.get()
      .apiML.get<Search.SearchResultsV2>('/hotels/search/init', query)
      .pipe(
        map(it => {
          return enrichPricesWithNights(nights)(it);
        }),
      );
  };

  export const searchV2Fetch = (
    criteria: FetchRequest,
    nights: number,
  ): Observable<Search.SearchResultsV2> => {
    criteria.how_many = Search.limitPerPage;

    return ApiModule.get()
      .apiML.get<Search.SearchResultsV2>('/hotels/search/fetch', criteria)
      .pipe(
        map(it => {
          return enrichPricesWithNights(nights)(it);
        }),
      );
  };

  const enrichPricesWithNights = (nights: number) => {
    return (it: Search.SearchResultsV2) => {
      const hotels = it.data.hotels.map(hotel => {
        return {
          ...hotel,
          price: {
            ...hotel.price,
            effectivePriceForNight: hotel.price.effectivePrice / nights,
          },
        };
      });

      it.data.hotels = hotels;
      return it;
    };
  };

  export const searchV2GetHotel = (
    id: string,
    translate?: boolean,
  ): Observable<HotelDetailsML.Details> => {
    return ApiModule.get()
      .apiML.get<HotelDetailsML.Response>(`/hotel/${id}/info`, { translate })
      .pipe(map(it => it.data));
  };
}
